export const USER_DATA_CONSTANT = {
  PROJECT_MENU: "PROJECT_MENU",
  ADD_PROJECT_MENU: "ADD_PROJECT_MENU",
  PROJECT_ID: "PROJECT_ID",
  SITE_ID: "SITE_ID",
  ADD_SITE_IDS: "ADD_SITE_IDS",
  TOGGLE_COLUMN: "TOGGLE_COLUMN",
  SET_EMPLOYEE_DATA: "SET_EMPLOYEE_DATA",
  SITE: "SITE",
  AREA_OF_OPERATION: "AREA_OF_OPERATION",
  DEPARTMENT: "DEPARTMENT",
  MY_INCIDENTS: "MY_INCIDENTS",
  INCIDENTS: "INCIDENTS",
  CONTRACTOR: "CONTRACTOR",
  CONTRACTOR_PERSON: "CONTRACTOR_PERSON",
  MEDICAL_ALL: "MEDICAL_ALL",
  DESTROY: "DESTROY",
  VIEW_VFL: "VIEW_VFL",
  MY_VFL: "MY_VFL",
  CAPA: "CAPA",
  ALL_EVENT_SCHEDULE: "ALL_EVENT_SCHEDULE",
  FORM_A: "FORM_A",
  BASIC_TRAINING: "BASIC_TRAINING",
  NEW_BASIC_TRAINING: "NEW_BASIC_TRAINING",
  TRAINING_BATCH_DETAILS: "TRAINING_BATCH_DETAILS",
  AVAILABLE_SITES: "AVAILABLE_SITES",
  MEDICAL_ALL_DONE: "MEDICAL_ALL_DONE",
  ALL_TRAINING_DATA: "ALL_TRAINING_DATA",
  CONTRACTOR_PERSON_FOR_OTHER_MODUEL: "CONTRACTOR_PERSON_FOR_OTHER_MODUEL",
  EMPLOYEE_FOR_OTHER_MODUEL: "EMPLOYEE_FOR_OTHER_MODUEL",
  CONTRACTOR_FOR_OTHER_MODUEL: "CONTRACTOR_FOR_OTHER_MODUEL",
  MEDICAL_IN_ACTIVE_UNASSIGNED: "MEDICAL_IN_ACTIVE_UNASSIGNED",
  MEDICAL_IN_ACTIVE_ASSIGNED: "MEDICAL_IN_ACTIVE_ASSIGNED",
  TRAINING_IN_ACTIVE_UNASSIGNED: "TRAINING_IN_ACTIVE_UNASSIGNED",
  TRAINING_IN_ACTIVE_ASSIGNED: "TRAINING_IN_ACTIVE_ASSIGNED",
  OLD_EMPLOYEE: "OLD_EMPLOYEE",
  OLD_CONTRACTOR_PERSON: "OLD_CONTRACTOR_PERSON",
  EMPLOYEE_IN_ACTIVE_UNASSIGNED: "EMPLOYEE_IN_ACTIVE_UNASSIGNED",
  EMPLOYEE_IN_ACTIVE_ASSIGNED: "EMPLOYEE_IN_ACTIVE_ASSIGNED",
  CONTRACTOR_PERSON_IN_ACTIVE_UNASSIGNED: "CONTRACTOR_PERSON_IN_ACTIVE_UNASSIGNED",
  CONTRACTOR_PERSON_IN_ACTIVE_ASSIGNED: "CONTRACTOR_PERSON_IN_ACTIVE_ASSIGNED",
};

export const SET_USER_DATA = "USER_SET_DATA";
export const REMOVE_USER_DATA = "USER_REMOVE_DATA";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const ADD_SITE_IDS = "ADD_SITE_IDS";
export const FILTER_STATUS_ADD = "FILTER_STATUS_ADD";
export const SET_PERIOD_MONTH_DATE = "SET_PERIOD_MONTH_DATE";
